import { Accordion, AccordionItemInterface, Button, Card, IconCheckmarkCircle, Modal, ProgressIndicator, Select, SelectOption } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../app/store";
import VisualInventory from "../../components/Activities/VisualInventory/VisualInventory";
import BackButton from "../../features/path/backButton";
import { IMaterialVisualInventoryDto } from "../../models/dto/agendaApi/IMaterialVisualInventoryDto";
import { IVisualInventoryDto } from "../../models/dto/agendaApi/IVisualInventoryDto";
import { MaterialClassificationEnum } from "../../models/enum/MaterialClassificationEnum";
import { VisualCategoryEnum } from "../../models/enum/VisualCategoryEnum";
import visualInventoryService from "../../services/agendaApi/visualInventory.service";
import groupBy from "../../utils/conversion";
import { Grid } from "@mui/material";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import '../../assets/css/views/activities/visualInventory.css';

export default function VisualExecutionInventory() {
    const [t] = useTranslation("global");
    const params = useParams();
    const [value, setValue] = useState<any[]>([]);
    const [options, setOptions] = useState<SelectOption[]>([]);
    const [accordionItems, setAccordionItems] = useState<AccordionItemInterface[]>([]);
    const languageId: any = useSelector((state: RootState) => state.languageId);
    const [materials, setMaterials] = useState<IMaterialVisualInventoryDto[]>();
    const [appointmentActivityId, setAppointmentActivityId] = useState(0);
    const [brandId, setBrandId] = useState(0);
    const [visualInventoryArray, setVisualInventoryArray] = useState<IVisualInventoryDto[]>([]);
    let visualInventory: IVisualInventoryDto[] = [];
    const [sendingData, setSendingData] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [disableButton, setDisableButton] = useState(true);
    const [highHasRecords, setHighHasRecords] = useState(false);
    const [mediumHasRecords, setMediumHasRecords] = useState(false);
    const [lowHasRecords, setLowHasRecords] = useState(false);
    const [appointmentId, setAppointmentId] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        getMaterialInventory(languageId.value);
    }, [languageId])

    useEffect(() => {
        setAppointmentActivityId(Number(params.id));
        setAppointmentId(Number(params.activityId));

    }, [])


    useEffect(() => {
        if (appointmentId > 0) {
            getBrands();
        }
    }, [appointmentId])

    useEffect(() => {
        setBrandId(value[0]);
    }, [value]);

    const getBrands = () => {
        visualInventoryService.getBrands(true, appointmentId)
            .then(result => {
                setOptions(result);
            });
    }

    useEffect(() => {
        if (options.length > 0) {
            const defaultValue = [options[0].value];
            setValue(defaultValue);
        }
    }, [options])

    useEffect(() => {
        if (materials) {
            let items: AccordionItemInterface[] = [
                {
                    id: "1",
                    content: <VisualInventory onSetValue={onSetValue} materialVisualInventory={materials?.filter(r => r.classificationType === MaterialClassificationEnum.High)} />,
                    header: { startArea: t("header.highVisibility"), centralArea: highHasRecords ? <IconCheckmarkCircle color="colorLightGreen6" filled /> : <></> },
                    expanded: true
                },
                {
                    id: "2",
                    content: <VisualInventory onSetValue={onSetValue} materialVisualInventory={materials?.filter(r => r.classificationType === MaterialClassificationEnum.Medium)} />,
                    header: { startArea: t("header.mediumVisibility"), centralArea: mediumHasRecords ? <IconCheckmarkCircle color="colorLightGreen6" filled /> : <></> },
                },
                {
                    id: "3",
                    content: <VisualInventory onSetValue={onSetValue} materialVisualInventory={materials?.filter(r => r.classificationType === MaterialClassificationEnum.Low)} />,
                    header: { startArea: t("header.lowVisibility"), centralArea: lowHasRecords ? <IconCheckmarkCircle color="colorLightGreen6" filled /> : <></> }
                }
            ]
            setAccordionItems(items);
        }
    }, [materials])

    const onSetValue = (quantity: number, materialTypeId: number, categoryId: number, classificationTypeId: number) => {
        const index = visualInventory.findIndex(v => v.materialTypeId === materialTypeId && v.categoryId === categoryId);
        if (quantity === 0) { //remove item
            if (index !== -1) {
                visualInventory.splice(index, 1);
            }
        } else {
            quantity = Math.round(quantity);
            if (index === -1) { //add item
                visualInventory.push({ quantity, appointmentActivityId: appointmentActivityId, materialTypeId, categoryId, brandId: value[0], classificationTypeId });
            } else {//update item
                visualInventory = visualInventory.map((v, i) => {
                    if (i === index) {
                        return { ...v, quantity: quantity }
                    } else {
                        return v;
                    }
                })
            }
        }
        setCheck(visualInventory, classificationTypeId);
        setVisualInventoryArray(visualInventory);
        setDisableButton(visualInventory.length === 0);
    }

    const setCheck = (visualInventory: IVisualInventoryDto[], classificationTypeId: number) => {
        const record = visualInventory.find(v => v.classificationTypeId === classificationTypeId);
        if (record) {
            switch (classificationTypeId) {
                case MaterialClassificationEnum.High:
                    setHighHasRecords(true);
                    break;
                case MaterialClassificationEnum.Medium:
                    setMediumHasRecords(true);
                    break;
                case MaterialClassificationEnum.Low:
                    setLowHasRecords(true);
                    break;
                default:
                    break;
            }
        } else {
            switch (classificationTypeId) {
                case MaterialClassificationEnum.High:
                    setHighHasRecords(false);
                    break;
                case MaterialClassificationEnum.Medium:
                    setMediumHasRecords(false);
                    break;
                case MaterialClassificationEnum.Low:
                    setLowHasRecords(false);
                    break;
                default:
                    break;
            }
        }
    }

    const getMaterialInventory = (languageId: number) => {
        setAccordionItems([]);
        setVisualInventoryArray([]);
        visualInventory = [];
        visualInventoryService.getMaterialInventory(languageId)
            .then((result: IMaterialVisualInventoryDto[]) => {
                setMaterials(result);
            })
    }

    const onChange = (selectedOption: any) => {
        setValue([selectedOption.value]);
    }

    const handleExpand = (event: any, index: any, item: any) => {
        const updatedData = [...accordionItems];
        updatedData[index].expanded = true;
        validateCheck();
        setAccordionItems(updatedData);
    };

    const handleCollapse = (event: any, index: any, item: any) => {
        const updatedData = [...accordionItems];
        updatedData[index].expanded = false;
        validateCheck();
        setAccordionItems(updatedData);
    };

    const validateCheck = () => {
        const accordions = [...accordionItems];
        for (let i = 0; i < accordions.length; i++) {
            switch (i) {
                case 0:
                    accordions[i].header = { startArea: accordions[i].header?.startArea, centralArea: highHasRecords ? <IconCheckmarkCircle color="colorLightGreen6" filled /> : <></> }
                    break;
                case 1:
                    accordions[i].header = { startArea: accordions[i].header?.startArea, centralArea: mediumHasRecords ? <IconCheckmarkCircle color="colorLightGreen6" filled /> : <></> }
                    break;
                case 2:
                    accordions[i].header = { startArea: accordions[i].header?.startArea, centralArea: lowHasRecords ? <IconCheckmarkCircle color="colorLightGreen6" filled /> : <></> }
                    break;
                default:
                    break;
            }
        }
    }

    const fillArrayZero = () => {
        visualInventory = visualInventoryArray;
        const visualGroup: any[][] = Object.values(groupBy(visualInventoryArray
            , 'materialTypeId'));
        for (let i = 0; i < visualGroup.length; i++) {
            let pc = false, print = false, supply = false;
            const element = visualGroup[i];

            for (let j = 0; j < element.length; j++) {
                const item = element[j];
                if (item.categoryId == VisualCategoryEnum.PcNotebooks)
                    pc = true;
                if (item.categoryId == VisualCategoryEnum.Print)
                    print = true;
                if (item.categoryId == VisualCategoryEnum.Supplies)
                    supply = true;
            }

            for (let j = 0; j < element.length; j++) {
                const item = element[j];
                if (!pc)
                    visualInventory.push({ appointmentActivityId: appointmentActivityId, brandId, categoryId: VisualCategoryEnum.PcNotebooks, materialTypeId: item.materialTypeId, quantity: 0, classificationTypeId: 0 })
                if (!print)
                    visualInventory.push({ appointmentActivityId: appointmentActivityId, brandId, categoryId: VisualCategoryEnum.Print, materialTypeId: item.materialTypeId, quantity: 0, classificationTypeId: 0 })
                if (!supply)
                    visualInventory.push({ appointmentActivityId: appointmentActivityId, brandId, categoryId: VisualCategoryEnum.Supplies, materialTypeId: item.materialTypeId, quantity: 0, classificationTypeId: 0 })
            }
        }
        setVisualInventoryArray(visualInventory);
    }

    //It's necessary because the brand's state is in context different  
    //to parent and it's necessary validate wether the brand has changed 
    const fillBrand = () => {
        visualInventory = visualInventoryArray;
        visualInventory.map(v => {
            v.brandId = brandId;
        });
        setVisualInventoryArray(visualInventory);
    };

    const sendVisualExecution = () => {
        setSendingData(true);
        fillBrand();
        fillArrayZero();
        visualInventoryService.insertVisualInventory(visualInventoryArray)
            .then(r => {
                setOpenModal(true);
                setSendingData(false);
                setVisualInventoryArray([])
            })
    }

    const closeModal = () => {
        navigate(-1);
    }

    return (
        <div>
            <div style={{ padding: '20px' }}>
                <BackButton route={BreadCrumbsEnum.VisualInventory} activityId={appointmentId} appointmentActivityId={appointmentActivityId} />
                <h4>{t("header.visualExecutionInventory")}</h4>
                <div style={{ padding: '20px' }}>
                    {
                        accordionItems.length === 0 ?
                            <div className="container">
                                <div className="vertical-center">
                                    <ProgressIndicator
                                        appearance="circular"
                                        behavior="indeterminate"
                                    />
                                </div>
                            </div> :
                            <div>
                                <Grid container spacing={2} style={{ marginBottom: '2%' }}>
                                    <Grid item xs={6} style={{ textAlign: 'left' }}>
                                        <Select
                                            clearIcon={false}
                                            showSearch
                                            options={options}
                                            id="select-usage"
                                            label={t("header.brand")}
                                            placement="bottom"
                                            helperTextVisibility="auto"
                                            onChange={onChange}
                                            value={value}
                                            className="selectVisualInventory"
                                        />
                                    </Grid>
                                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                                        {
                                            accordionItems.length > 0 &&
                                            <Button disabled={disableButton || sendingData} onClick={sendVisualExecution} >
                                                {t("modal.saveTitleInfo")}
                                            </Button>
                                        }
                                    </Grid>
                                </Grid>
                                {
                                    value.length > 0 &&
                                    <div>
                                        <Card
                                            appearance="dropShadow"
                                            style={{ padding: '2%', height: '100%' }}
                                            content={
                                                <div>
                                                    <Accordion
                                                        appearance="outlined"
                                                        gutter={15}
                                                        behavior="singleExpand"
                                                        items={accordionItems}
                                                        onCollapse={handleCollapse}
                                                        onExpand={handleExpand}
                                                    />
                                                </div>
                                            }
                                        />
                                    </div>
                                }
                            </div>
                    }
                </div>
                <Modal
                    align="start"
                    id="modal-id"
                    show={openModal}
                    onClose={() => closeModal()}
                    footer={(
                        <div style={{ textAlign: 'center' }}>
                            <Button style={{ marginRight: 4 }} onClick={closeModal}>{t('header.confirm')}</Button>
                        </div>
                    )}
                    title={t("header.information")}>
                    <p>
                        {t("modal.saveSuccess")}
                    </p>
                </Modal>
            </div >
        </div >
    )
}